import { toBN } from 'web3-utils';
import { estimatePriorityFee } from "./contractService";

const STAR_CHEST_BACKEND = process.env.REACT_APP_STAR_CHEST_BACKEND_URL;
const BACKEND_API = process.env.REACT_APP_BACKEND_API;

export const getChestInfo = async (cdhUserId, jwtToken='', cachedData = true) => {
    try {
        let getChestBody = {
            playerId: cdhUserId
        };
        if (cachedData === false) {
            getChestBody.cachedData = false;
        }

        const url = STAR_CHEST_BACKEND + '/get_star_chest_info';
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': jwtToken
            },
            body: JSON.stringify(getChestBody)
        };

        let chestInfo = await fetch(url, options);
        if (chestInfo.status == 500 || chestInfo.status == 401) {
            return null;
        }

        let response = await chestInfo.json();
        return response;
    } catch (err) {
        console.error('Error fetching data: ' + err);
    }
};

export const getUniquePlayerId = async (cdhUserId, jwtToken='') => {
    try {
        const url = STAR_CHEST_BACKEND + '/id_generator';
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': jwtToken
            },
            body: JSON.stringify({
                playerId: cdhUserId
            })
        };

        let playerId = await fetch(url, options);
        if (playerId.status == 500) {
            return null;
        }

        let response = await playerId.json();
        return response;
    } catch (err) {
        console.error('Error fetching data: ' + err);
    }
}

export const getRewardsHistoryRecords = async (cdhUserId, jwtToken='') => {
    try {
        const url = STAR_CHEST_BACKEND + '/get_reward_history';
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': jwtToken
            },
            body: JSON.stringify({
                playerId: cdhUserId
            })
        };

        let rewardsHistory = await fetch(url, options);
        if (rewardsHistory.status == 500) {
            return null;
        }

        let response = await rewardsHistory.json();
        return response;
    } catch (err) {
        console.error('Error fetching data: ' + err);
    }
}

export const getMaticToWallet = async (walletSignature, playerId, captchaToken, jwtToken='') => {
    const url = STAR_CHEST_BACKEND + '/matic_faucet_verified';
    try {
        console.log({
            signature: walletSignature,
            playerId: playerId
        });
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': jwtToken
            },
            body: JSON.stringify({
                signature: walletSignature,
                playerId: playerId,
                token: captchaToken
            })
        };
        const response = await fetch(url, options);
        if (response.status == 500) {
            return null;
        }
        const obj = await response.json();
        return obj;
    } catch (err) {
        console.error('Error fetching data: ' + err)
    }
}

export const getJWToken = async (playerId, token) => {
    const url = BACKEND_API + '/jwt';
    try {
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                playerId: playerId,
                token: token
            })
        };
        const response = await fetch(url, options);
        if (response.status == 500) {
            return null;
        }
        const obj = await response.json();
        return obj;
    } catch (err) {
        console.error('Error fetching data: ' + err);
    }
}

export const verifyCatchUp = async (fingerprint, walletAddress, playerId) => {
    const url = BACKEND_API + '/catchup/verify';
    try {
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                fingerprint: fingerprint,
                walletAddress: walletAddress,
                playerId: playerId,
            })
        };
        const response = await fetch(url, options);
        const obj = await response.json();

        if (response.status === 500 && obj?.message?.includes('Nonce-Mismatch')) {
            return "pending";
        }

        if (response.status === 500) {
            return null;
        }
        return obj?.data;
    } catch (err) {
        console.error('Error verifying catch up: ' + err);
    }
}

export const setTowerAllowanceForCatchUp = async (towerContract, selectedAccount, spenderAddress, approvalAmount, web3, catchUpPendingCallBack) => {
    try {
        let gasPrice = await web3.eth.getGasPrice();
        let gasPriceBN = toBN(gasPrice);
        let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.3 * gasPriceBN))).toString();
        let gasEstimate = await towerContract.methods
            .approve(spenderAddress, approvalAmount)
            .estimateGas({from: selectedAccount});
        let estimatedPriorityFee = await estimatePriorityFee(web3);
        let finalMaxFeePerGas = toBN(finalGasPrice).add(toBN(parseInt(0.3 * estimatedPriorityFee))).toString();

        let receipt = await towerContract.methods.approve(spenderAddress, approvalAmount)
            .send({
                from: selectedAccount,
                gasLimit: gasEstimate,
                gasPrice: finalGasPrice,
                maxFeePerGas: finalMaxFeePerGas,
                maxPriorityFeePerGas: estimatedPriorityFee
            })
            .on('transactionHash', txHash => {
                console.log(`txHash: ${txHash}`);
            })
            .on('receipt', (receipt) => {
                console.log("receipt: ", receipt);
            });

        if (receipt.status === true) {
            return true;
        }
        return false;
    } catch (err) {
        console.error(`Transaction failed: ${err.message}`);
        catchUpPendingCallBack(false, '', '', '');
        if (err.code === 4001) {
            return "reject";
        }
    }
}

export const catchUpMissedDays = async (contract, web3, selectedAccount, playerId, catchUpDays, amount, signature, catchUpPendingCallBack) => {
    try {
        let isPaused = await contract.methods.paused().call();
        if (isPaused) {
            return;
        }

        let gasPrice = await web3.eth.getGasPrice();
        let gasPriceBN = toBN(gasPrice);
        let finalGasPrice = gasPriceBN.add(toBN(parseInt(0.3 * gasPriceBN))).toString();
        let gasEstimate = await contract.methods.checkInCatchup(playerId, catchUpDays, amount, signature).estimateGas({ from: selectedAccount });
        let estimatedPriorityFee = await estimatePriorityFee(web3);
        let finalMaxFeePerGas = toBN(finalGasPrice).add(toBN(parseInt(0.3 * estimatedPriorityFee))).toString();

        const receipt = await contract.methods.checkInCatchup(playerId, catchUpDays, amount, signature).send({
            from: selectedAccount,
            gasLimit: gasEstimate,
            gasPrice: finalGasPrice,
            maxFeePerGas: finalMaxFeePerGas,
            maxPriorityFeePerGas: estimatedPriorityFee
        })
            .on('transactionHash', (txHash) => {
                console.log(`Transaction hash obtained : ${txHash}`);
                catchUpPendingCallBack(true, catchUpDays, web3.utils.fromWei(amount).toString(), txHash);
            })
            .on('receipt', (receipt) => {
                catchUpPendingCallBack(false, '', '', '');
                console.log("receipt:", receipt);
            });
            
        if (receipt.status === true) {
            return true;
        }

    } catch (err) {
        console.log(err);
        console.error(`Transaction failed: ${err.message}`);
        catchUpPendingCallBack(false, '', '', '');
        if (err.code === 4001) {
            return "reject";
        }
    }
}